
import {  Container, Button, Grid, Link, makeStyles,  CssBaseline, CircularProgress, TextField } from '@material-ui/core';
import React, { useState, KeyboardEvent } from 'react'
import axios, { AxiosRequestConfig } from 'axios';
import { useHistory } from 'react-router';
import { Logo } from '../../components/ui/Logo';
import toast from 'react-hot-toast';
import { icon_backButton } from '../../assets/images/images';
import { planEatApi } from '../../planEatApi/PlanEatApi';

const useStyles = makeStyles((theme: any) => ({
    topbarContainer: {
        padding: 12,
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: "absolute"
    },
    paper: {
        marginTop: 50,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    inputFieldContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: 15
    },
    loginContainer: {
        marginTop: '6%',
        color: '#999999'
    },
    title: {
        marginTop: '2%',
        marginBottom: '5%',
        fontSize: 20,
        fontWeight: 700
    },
    sendEmailButton: {
        color: 'white',
        fontSize: 12,
        padding: 10,
        fontWeight: 700,
        letterSpacing: 2,
        marginTop: 50
    },
    link:{
        color: '#999999',
        marginTop: '15%'
    }
}));

export const ForgotLogin: React.FC = () => {
    // Styling 
    const classes = useStyles();

    // Routing
    let history = useHistory();

    // State
    const [loadingHidden,setLoadingHidden] = useState(true);
    const [email, setEmail] = useState("")

    function sendResetLink() {
        setLoadingHidden(false)
        planEatApi.postForgotPassword(email)
        .then((response) => {
            toast.success("Forgot password email sent")
            setLoadingHidden(true)  
        })
        .catch(e => {
            toast.error("Something went wrong")
            setLoadingHidden(true)
        })

    }

    const handleEnterDown = (e: KeyboardEvent) => {
        if(e.key=== "Enter"){
            sendResetLink()
        }
    }

    return (
        <div>
            <div className={classes.topbarContainer}>
                <div>
                    <img src={icon_backButton} alt="backButton" onClick={() => { history.push('') }} style={{ cursor: 'pointer' }} />
                </div>
            </div>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className={classes.paper}>
                    <Logo variant='normal' />   
                    <div className={classes.title}>
                        Forgot Login
                    </div>
                    <div className={classes.inputFieldContainer}>
                        <TextField
                            margin="normal"
                            fullWidth
                            id="email"
                            label="Email"
                            name="email"
                            autoComplete="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyDown={(e) => handleEnterDown(e)}
                            autoFocus
                        />
                    </div>
                    <Button
                        fullWidth
                        variant="contained"
                        className={classes.sendEmailButton}
                        onClick={sendResetLink}
                    >
                        SEND EMAIL
                    </Button>
                    <Grid
                        container
                        direction="column"
                        justifyContent="space-around"
                        alignItems="center"
                        className={classes.loginContainer}
                    >
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Link variant="body2" color="inherit" onClick={() => { history.push('') }} className={classes.link}>
                                Already have an account? <b>Login</b>
                            </Link>
                        </Grid>
                    </Grid>
                </div>
            </Container>
            <div hidden={loadingHidden} style={{
                    position: "fixed",
                    display: "flex",
                    justifyContent:'center',
                    alignItems:'center',
                    width: "100%",
                    height: "100%",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 2
                }}>
                    <CircularProgress />
            </div>
        </div>
    );
}